import getEnv from "../util/env"

export const portalURL: string = getEnv("VITE_APP_DIH_URL")
export const portalDocUrl: string = getEnv("VITE_APP_DIH_DOC_URL")

export const PortalLinks = {
  en: {
    termsandcondition: `${portalURL}/cms/assets/33b9a515-391d-411d-8c28-98e2f9d674eb/General%20T%26Cs%20for%20IT%20Services.pdf`,
    contact: `${portalURL}/en/contact`,
    imprint: `${portalURL}/en/imprint`,
    privacypolicy: `${portalURL}/en/privacy-policy`,
    cookiesettings: `${portalURL}/en`,
    help: `${portalURL}/en/help`
  },
  de: {
    termsandcondition: `${portalURL}/cms/assets/9cf6db64-949b-4891-9b13-4c0c06d7a812/Allgemeine%20Gesch%C3%A4ftsbedingungen%20IT-Leistungen.pdf`,
    contact: `${portalURL}/de/kontakt`,
    imprint: `${portalURL}/de/impressum`,
    privacypolicy: `${portalURL}/de/privacy-policy`,
    cookiesettings: `${portalURL}/de`,
    help: `${portalURL}/de/help`
  }
}

export const helpLinks = {
  provider: {
    subModel: {
      help: `${portalDocUrl}/e/en/connect-catena-x/types-of-submodels-in-catena-x`
    },
    policies: {
      help: `${portalDocUrl}/e/en/connect-catena-x/policy-overview-in-catena-x`
    }
  },
  help: {
    documentation: `${portalDocUrl}/en/connect`
  }
}
